(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pc-announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pc-announcement-vertical').forEach(function (wrapper) {
    var track = wrapper.querySelector('.pc-announcement-vertical-track');
    if (!track) return;

    var items = track.querySelectorAll('.pc-announcement-item');
    if (items.length <= 1) return; // need at least 2 messages to scroll

    var index = 0;
    var itemHeight = items[0].offsetHeight;
    var speed = parseInt(wrapper.getAttribute('data-rotate-speed'), 10) || 4000;

    // Ensure container height matches one row
    wrapper.style.height = itemHeight + 'px';

    setInterval(function () {
      index = (index + 1) % items.length;
      track.style.transform = 'translateY(' + (-index * itemHeight) + 'px)';
    }, speed);
  });
});

  } catch(e) { console.error(e); }
})();
})();
